import { render, staticRenderFns } from "./DialogComments.vue?vue&type=template&id=7c05347f&scoped=true"
import script from "./DialogComments.vue?vue&type=script&lang=js"
export * from "./DialogComments.vue?vue&type=script&lang=js"
import style0 from "./DialogComments.vue?vue&type=style&index=0&id=7c05347f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c05347f",
  null
  
)

export default component.exports